import { render, staticRenderFns } from "./IndustrySpecificProfile.vue?vue&type=template&id=80f48208"
import script from "./IndustrySpecificProfile.vue?vue&type=script&lang=js"
export * from "./IndustrySpecificProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports